import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { ContentComponent, FooterComponent, HeaderComponent, LayoutComponent } from '@public/core/ui/layout';

import { FooterContentComponent, HeaderContentComponent } from '@naturfond/common';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    ContentComponent,
    FooterComponent,
    HeaderComponent,
    LayoutComponent,
    FooterContentComponent,
    HeaderContentComponent,
  ],
})
export class HomeComponent implements OnInit {
  constructor(private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle('Naturfond Gl. Rye');
  }
}
